  <div class="flex flex-col min-w-0 max-w-full">
    <div class="px-6 pt-4 pb-2 shrink-0">
    <div class="flex justify-between items-center">
        <h1 class="text-2xl font-bold text-gray-800">Produtos Ativos</h1>
      </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
      <input #searchInput type="text" (input)="onSearchChange()" [(ngModel)]="searchTerm" placeholder="Buscar por nome ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} produto(s) encontrado(s)
      </div>
    </div>
  </div>

  <div class="flex-1 px-6 py-4 bg-gray-50 min-h-0 min-w-0 overflow-hidden">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="products" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-left px-6 py-3">Código | Código de Barras</th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Preço</th>
            <th class="text-left px-6 py-3">Estoque</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ product.code }} | {{ product.barCode }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ product.description }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ product.priceSelling | number: '1.2-2' }}</td>
            <td class="px-6 py-2">
              <span class="px-2 py-1 rounded-full text-xs" [ngClass]="{
                'bg-green-100 text-green-800': product.currentStock >= product.minimumStock,
                'bg-yellow-100 text-yellow-800': product.currentStock < product.minimumStock && product.currentStock > 0,
                'bg-red-100 text-red-800': product.currentStock < 0
              }">{{ product.currentStock }}</span>
            </td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <button (click)="select(product)" type="button" class="text-white cursor-pointer bg-orange-500 px-3 py-2 rounded hover:bg-orange-600">
                  <i class="pi pi-pencil mr-3"><span class="ml-1">Selecionar</span></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhum produto encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
  </div>
</div>